// const baseUrl = "http://localhost:5555";
// const baseUrl = "https://instructor.teachera.co";
const baseUrl = "https://api.employscope.com";
export { baseUrl };

//perchese
//active InActive in videoList
